import { defaultSerializeQueryArgs } from './defaultSerializeQueryArgs.js';
import { DefinitionType } from './endpointDefinitions.js';

function buildCreateApi(...modules) {
  return function baseCreateApi(options) {
    const optionsWithDefaults = {
      reducerPath: 'api',
      serializeQueryArgs: defaultSerializeQueryArgs,
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: false,
      refetchOnFocus: false,
      refetchOnReconnect: false,
      ...options,
      entityTypes: [...(options.entityTypes || [])]
    };
    const context = {
      endpointDefinitions: {},

      batch(fn) {
        // dummy "batch" method to be overridden by plugins, for example with React.unstable_batchedUpdate
        fn();
      }

    };
    const api = {
      injectEndpoints,

      enhanceEndpoints({
        addEntityTypes,
        endpoints
      }) {
        if (addEntityTypes) {
          for (const eT of addEntityTypes) {
            if (!optionsWithDefaults.entityTypes.includes(eT)) {
              optionsWithDefaults.entityTypes.push(eT);
            }
          }
        }

        if (endpoints) {
          for (const [endpoint, partialDefinition] of Object.entries(endpoints)) {
            if (typeof partialDefinition === 'function') {
              partialDefinition(context.endpointDefinitions[endpoint]);
            }

            Object.assign(context.endpointDefinitions[endpoint] || {}, partialDefinition);
          }
        }

        return api;
      }

    };
    const initializedModules = modules.map(m => m.init(api, optionsWithDefaults, context));

    function injectEndpoints(inject) {
      const evaluatedEndpoints = inject.endpoints({
        query: x => ({ ...x,
          type: DefinitionType.query
        }),
        mutation: x => ({ ...x,
          type: DefinitionType.mutation
        })
      });

      for (const [endpoint, definition] of Object.entries(evaluatedEndpoints)) {
        if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
          if (!inject.overrideExisting && endpoint in context.endpointDefinitions) {
            console.error(`called \`injectEndpoints\` to override already-existing endpoint ${endpoint} without specifying \`overrideExisting: true\``);
            continue;
          }
        }

        context.endpointDefinitions[endpoint] = definition;

        for (const m of initializedModules) {
          m.injectEndpoint(endpoint, definition);
        }
      }

      return api;
    }

    return api.injectEndpoints({
      endpoints: options.endpoints
    });
  };
}

export { buildCreateApi };
//# sourceMappingURL=createApi.js.map
